"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = require("reselect");
var ramda_1 = require("ramda");
var api_1 = require("../../utils/api");
var constants_1 = require("./constants");
var moduleState = function (rootState) { return rootState[constants_1.namespace]; };
var results = api_1.createApiSelector(moduleState, 'result');
exports.result = reselect_1.createSelector(results, function (state) { return state.data; });
exports.resultIsLoading = reselect_1.createSelector(results, function (state) { return state.isLoading; });
exports.resultError = reselect_1.createSelector(results, function (state) { return state.error; });
exports.query = api_1.createApiSelector(moduleState, 'query');
var suggestions = api_1.createApiSelector(moduleState, 'suggestions');
exports.popular = api_1.createApiSelector(moduleState, 'popular');
exports.similar = api_1.createApiSelector(moduleState, 'similar');
exports.suggestionsResult = reselect_1.createSelector(suggestions, function (state) { var _a; return (_a = state.data) === null || _a === void 0 ? void 0 : _a.filter(function (item) { return !ramda_1.isNil(item); }).map(function (item) { return item.title; }); });
exports.suggestionsIsLoading = reselect_1.createSelector(suggestions, function (state) { return state.isLoading; });
//# sourceMappingURL=selectors.js.map